import '../../util/string';
import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import style from './NewPatientButtonTabs.module.css';
import { connect } from 'react-redux';
import { withLang } from '../../util/lang';
import ErrorDialog from './ErrorDialog/ErrorDialog';
import { dialogData, setDialog, setDialogFunction, setDialogMessage } from '../../store/ErrorMessage/ErrorMessageSlice';
import { smileDesignProductListArray } from '../../store/SmileDesign/SmileDesignSlice';
import { validateImpressionFiles } from './NewPatientUtill';
import {
    alignerPrescriptionFormValidation,
    handleValidationOnTabsChange,
} from '../../util/alignerPrescriptionFormHelper';
import { Base_Prescription_Err, CASE_TYPE } from '../../store/NewPatient/utils';
// import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
class NewPatientButtonTabs extends Component {
    constructor(props) {
        super(props);
        // let initialTabMode = ["info", "prescriptionNotes", "photos", "radiography", "impression", "delivery", "summary"]

        // if (this.props.NewCaseType == 'RETAINER') {
        //   initialTabMode = ["info", "retainer_request_prescriptionNotes", "impression", "delivery", "summary"]
        // }
        this.state = {
            // tabMode: initialTabMode,
            prev: '',
            next: '',
            tabs: this.props.tabs,
        };
        this.submitData = this.submitData.bind(this);
        this.handleChangeTab = this.handleChangeTab.bind(this);
    }

    /**
     * Validates the current tab before changing to the requested tab.
     */
    handleChangeTab(inc) {
        if (typeof inc === 'number') {
            inc = Math.min(1, Math.max(-1, inc));
        } else {
            throw new Error('unknown tab change');
        }
        if (this.props.tabMode === 'info') {
            if (this.props.NewPaitientData.firstName.length == 0) {
                this.props.setDialogMessage(dialogData.firstName.content);
                this.props.handleValidation({ firstName: 'First Name is required' });
            } else if (this.props.NewPaitientData.lastName.length == 0) {
                this.props.handleValidation({ lastName: 'Last Name is required' });
                this.props.setDialogMessage(dialogData.lastName.content);
            } else {
                this.props.ErrorData({ id: 'patient_info', msg: '', valid: true });
                this.changetab(inc);
            }
        } else if (this.props.tabMode === 'delivery') {
            if (
                this.props.NewPatientAddressData.delivery_id == 'New Address' &&
                this.props.NewPatientAddressData.city.length == 0
            ) {
                this.props.setDialogMessage(dialogData.city.content);
            } else if (
                this.props.NewPatientAddressData.delivery_id == 'New Address' &&
                this.props.NewPatientAddressData.zipCode.length == 0
            ) {
                this.props.setDialogMessage(dialogData.zipCode.content);
            } else if (
                this.props.NewPatientAddressData.delivery_id == 'New Address' &&
                this.props.NewPatientAddressData.phoneNumber.length == 0
            ) {
                this.props.setDialogMessage(dialogData.phone.content);
            } else {
                this.changetab(inc);
            }
        } else if (this.props.tabMode === 'photos') {
            let counter = 0;
            if (this.props.NewCaseType !== 'RETAINER') {
                this.props.NewPaitientData.files.map((v) => {
                    if (
                        [
                            'jaw_side_with_smile',
                            'face_front_with_smile',
                            'teeth_side_without_smile',
                            'jaw_front_with_smile',
                            'teeth_side_with_smile',
                            'jaw_side_without_smile',
                            ...(this.props.displayFirstFitFlag ? ['big_smile_full_face_with_full_retractors'] : []),
                        ].includes(v.id) &&
                        !v.data &&
                        !v.upload_later &&
                        !v.will_not_upload
                    ) {
                        counter += 1;
                    }
                });
            }
            if (counter && this.props.NewCaseType !== 'RETAINER') {
                this.props.ErrorData({ id: 'photo', msg: this.get('warning.mandatoryPhoto'), valid: false });
            } else {
                this.props.ErrorData({ id: 'photo', msg: '', valid: true });
            }
            this.changetab(inc);
        } else if (this.props.tabMode === 'radiography') {
            let counter = 0;
            if (this.props.NewCaseType !== 'RETAINER') {
                this.props.NewPaitientData.files.map((v, index) => {
                    if (
                        v.category === 'radio' &&
                        v.id === 'front_with_smile' &&
                        !v.data &&
                        !v.upload_later &&
                        !v.will_not_upload
                    ) {
                        counter += 1;
                    }
                });
            }
            if (counter && this.props.NewCaseType !== 'RETAINER') {
                this.props.ErrorData({ id: 'radiograph', msg: this.get('warning.mandatoryRadiograph'), valid: false });
            } else {
                this.props.ErrorData({ id: 'radiograph', msg: '', valid: true });
            }
            this.changetab(inc);
        } else if (this.props.tabMode === 'impression') {
            switch (this.props.NewPaitientData.impressionType) {
                case 'FILE': {
                    const impressionFiles = this.props.NewPaitientData.files.filter((v) => v.category === 'stl_file');
                    const impressionErrList = validateImpressionFiles(impressionFiles);
                    if (impressionErrList.length > 0) {
                        this.props.ErrorData({ id: 'impression', msg: this.get('warning.allStl'), valid: false });
                    } else {
                        this.props.ErrorData({ id: 'impression', msg: '', valid: true });
                    }
                    break;
                }
                case 'COURIER': {
                    if (String.isBlank(this.props.NewPaitientData.modernCode)) {
                        this.props.ErrorData({ id: 'impression', msg: this.get('warning.courier'), valid: false });
                    } else {
                        this.props.ErrorData({ id: 'impression', msg: '', valid: true });
                    }
                    break;
                }
                case 'SCANNER': {
                    if (
                        String.isBlank(this.props.NewPaitientData.scannerBrand) ||
                        String.isBlank(this.props.NewPaitientData.doctorId)
                    ) {
                        this.props.ErrorData({ id: 'impression', msg: this.get('warning.scanner'), valid: false });
                    } else {
                        this.props.ErrorData({ id: 'impression', msg: '', valid: true });
                    }
                    break;
                }
            }
            this.changetab(inc);
        } else if (
            this.props.tabMode === 'prescriptionNotes' &&
            !smileDesignProductListArray.includes(this.props.NewCaseType)
        ) {
            // Update prescription error state without blocking step navigation.
            const {
                attachments1,
                spacingAndCrowding1,
                openbite1,
                deepBite1,
                midline1,
                posteriorCrossbite1,
                auxiliaries1,
                restorativeOptions,
                preImplantAligment,
                archToTreat,
                anteriorPosteriorRelationship1,
            } = this.props.NewPaitientData;
            const {
                condition1,
                condition3,
                condition4,
                condition5,
                condition6,
                condition7,
                condition8,
                condition9,
                condition10,
                condition11,
                condition12,
                condition13,
                condition14,
                condition16,
                condition17,
                condition18,
                condition19,
                condition20,
                condition21,
                condition22,
                restorativeOptionsSubValueOnlayErr,
                restorativeOptionsVerticalDimensionUpperPosteriorErr,
                restorativeOptionsVerticalDimensionLowerPosteriorErr,
                preImplantAligmentProstheticSpaceErr,
            } = alignerPrescriptionFormValidation({
                attachments: attachments1,
                spacingAndCrowding: spacingAndCrowding1,
                openbite: openbite1,
                deepBite: deepBite1,
                midline: midline1,
                posteriorCrossbite: posteriorCrossbite1,
                auxiliaries: auxiliaries1,
                restorativeOptions,
                preImplantAligment,
                archToTreat,
                anteriorPosteriorRelationship: anteriorPosteriorRelationship1,
            });
            const errorResponse = handleValidationOnTabsChange({
                condition1,
                condition3,
                condition4,
                condition5,
                condition6,
                condition7,
                condition8,
                condition9,
                condition10,
                condition11,
                condition12,
                condition13,
                condition14,
                condition16,
                condition17,
                condition18,
                condition19,
                condition20,
                condition21,
                condition22,
                restorativeOptionsSubValueOnlayErr,
                restorativeOptionsVerticalDimensionPosteriorErr:
                    restorativeOptionsVerticalDimensionUpperPosteriorErr &&
                    restorativeOptionsVerticalDimensionLowerPosteriorErr,
                preImplantAligmentProstheticSpaceErr,
            });

            if (!errorResponse.needHandle) {
                this.props.ErrorData({ id: Base_Prescription_Err.id, msg: Base_Prescription_Err.msg, valid: true });
                this.changetab(inc);
            } else {
                this.props.setDialog({
                    title: '@global.const.actionRequired',
                    content: '@NewPatient.warning.prescription_notes',
                });
                this.props.handlePrescriptionErrorQuestion(errorResponse.errorQuestion);
                this.props.handlePrescriptionErrorScrollId(errorResponse.scrollId);
                this.props.ErrorData({
                    id: Base_Prescription_Err.id,
                    msg: this.get('warning.prescription_notes') || Base_Prescription_Err.msg,
                    valid: false,
                });
            }
        } else if (
            this.props.tabMode === 'prescriptionNotes' &&
            this.props.tabs.includes('prescriptionNotesSD')
        ) {
            // Apply Q14 defaults to ISD form before navigating to ISD tab
            if (typeof this.props.smileDesign.applyQ14DefaultsToISDForm === 'function') {
                this.props.smileDesign.applyQ14DefaultsToISDForm();
            }
            this.changetab(inc);
        } else if (this.props.tabMode === 'prescriptionNotesSD') {
            // Validate Q4/Q14 match before leaving ISD tab (only when going forward)
            if (inc > 0 && typeof this.props.smileDesign.validateISDQ4Q14Match === 'function') {
                const isMatch = this.props.smileDesign.validateISDQ4Q14Match();
                if (!isMatch) {
                    this.props.setDialogMessage(
                        '@NewPatient.warning.verticalDimensionMismatch'
                    );
                    return;
                }
            }
            this.changetab(inc);
        } else {
            this.changetab(inc);
        }
        this.props.setDialogFunction(() => this.props.handlePrescriptionErrorScroll());
    }

    changetab(inc) {
        if (typeof inc === 'number') {
            inc = Math.min(1, Math.max(-1, inc));
        } else {
            throw new Error('unknown tab change');
        }
        // let currentIndexVal = this.state.tabMode.indexOf(this.props.tabMode)
        // if (currentIndexVal < 0) throw new Error('unknown next tab')
        // let nextState = this.state.tabMode[currentIndexVal + inc]
        let currentIndexVal = this.props.tabs.indexOf(this.props.tabMode);
        if (currentIndexVal < 0) throw new Error('unknown next tab');
        let nextState = this.props.tabs[currentIndexVal + inc];
        this.setState({ next: nextState, current: nextState });
        this.props.handleChangeTab(nextState);
        this.props.handleValidation({});

        // Purpose: validate the case if it is smile design
        smileDesignProductListArray.includes(this.props.NewCaseType) &&
            this.props.smileDesign.handleValidateSmileDesignPrescriptionNotes();
    }
    submitData(e) {
        // Self-Design case type does not require impression/files upload, skip error validation
        if (this.props.NewCaseType === CASE_TYPE.SELF_DESIGN) {
            this.props.handleSave('submitted');
            return;
        }

        let errors = this.props.NewPaitientData.errors;
        let counter = 0;
        errors.map((v) => {
            if (!v.valid) {
                counter++;
            }
        });

        if (smileDesignProductListArray.includes(this.props.NewCaseType)) {
            // Purpose: check if the case is smile design
            if (counter || !this.props.smileDesign.smileDesignPrescriptionFormIsValid) {
                this.props.setDialogMessage(dialogData.allMandatory.content);
            } else {
                this.props.handleSave('submitted');
            }
        } else {
            if (counter) {
                this.props.setDialogMessage(dialogData.allMandatory.content);
            } else {
                this.props.handleSave('submitted');
            }
        }
    }
    render() {
        const { isTabsReady } = this.props;
        // console.log("this.props.tabs => ", this.props.tabs)
        // console.log("this.state.tabs => ", this.state.tabs)
        return (
            <Grid item xs={12}>
                <ErrorDialog />
                <div className={this.props.displayFirstFitFlag ? style.customButtonFirstFit : style.customButton} >
                    {this.props.tabMode !== 'info' && this.props.tabMode !== 'summary' && (
                        <button
                            className={this.props.displayFirstFitFlag ? style.previous : ''}
                            style={!this.props.displayFirstFitFlag  ? { border: 'solid #593687 2px', backgroundColor: 'transparent', color: '#593687' } :{}}
                            type="button"
                            onClick={() => this.handleChangeTab(-1)}
                        >
                            {/* <div style={{display:'flex',alignContent: 'center',alignItems: 'center'}}> */}
                                {/* <ArrowBackIosIcon style={{ width: 16, height: 16 }}></ArrowBackIosIcon> */}
                               {this.get('navBtns.previous')}
                            {/* </div> */}
                        </button>
                    )}

                    <>
                        {!smileDesignProductListArray.includes(this.props.NewCaseType) && (
                            <>
                                {this.props.tabMode !== 'info' &&
                                    this.props.tabMode !== 'summary' &&
                                    this.props.from !== 'new_order' && (
                                        <button
                                            type="button"
                                            className={style.next}
                                            value="tempSave"
                                            onClick={(e) => this.props.handleSave('tempSave')}
                                        >
                                            {this.get('navBtns.saveDraft')}
                                        </button>
                                    )}
                            </>
                        )}
                    </>

                    {this.props.tabMode !== 'summary' ? (
                        <button
                            type="button"
                            disabled={!isTabsReady}
                            onClick={() => this.handleChangeTab(1)}
                            className={style.next}
                        >
                            {this.get('navBtns.next')}
                        </button>
                    ) : (
                        <button type="button" className={style.next} onClick={this.submitData} value="save">
                            {this.get('navBtns.submit')}
                        </button>
                    )}
                </div>
            </Grid>
        );
    }
}

/**
 * Maps Redux state to tab navigation props.
 */
const mapStateToProps = (store) => {
    return {
        NewPaitientData: store.newPatientReducer,
        lang: store.lang,
        smileDesign: store.smileDesign,
        displayFirstFitFlag: store.globalReducer.displayFirstFitFlag,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        ErrorData: (errorMsg) => dispatch({ type: 'NEW_PATIENT_DATA_ERROR', errorMsg: errorMsg }),
        handlePrescriptionError: (error) => dispatch({ type: 'NEW_PATIENT_PRES_ERROR', error }),
        handlePrescriptionErrorScroll: () => dispatch({ type: 'NEW_PATIENT_PRES_ERROR_SCROLL' }),

        setDialogMessage: (errorMsg) => dispatch(setDialogMessage(errorMsg)),
        setDialog: (payload) => dispatch(setDialog(payload)),
        setDialogFunction: (func) => dispatch(setDialogFunction(func)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withLang(NewPatientButtonTabs, 'NewPatient'));
